import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Music } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_piano-course-hub-1/artifacts/twyyu2ir_NSM%20White.png";

export const Header = ({ variant = 'default' }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  const navLinks = isAdmin ? [
    { href: '/', label: 'Home' },
    { href: '/admin', label: 'Dashboard' },
    { href: '/admin/courses', label: 'Course Guide' },
    { href: '/admin/settings', label: 'Class Settings' },
  ] : [
    { href: '/', label: 'Home' },
    { href: '/repackage', label: 'Current Student' },
    { href: '/returning', label: 'Returning Student' },
    { href: '/track', label: 'Track Application' },
  ];

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 glass border-b border-white/10 ${variant === 'solid' ? 'bg-[#0a0a0a]' : ''}`}>
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3" data-testid="logo-link">
            <img
              src={LOGO_URL}
              alt="Nathaniel School of Music"
              className="h-10 md:h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`font-body text-sm tracking-wide transition-colors ${
                  location.pathname === link.href
                    ? 'text-[#D4AF37]'
                    : 'text-[#A1A1AA] hover:text-[#F5F5DC]'
                }`}
                data-testid={`nav-${link.label.toLowerCase().replace(' ', '-')}`}
              >
                {link.label}
              </Link>
            ))}

            {!isAdmin && (
              <Link to="/apply" data-testid="join-now-btn">
                <Button className="btn-gold rounded-full px-6 py-2 font-semibold text-sm">
                  Join Now
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#EDEDED] p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            data-testid="mobile-menu-btn"
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-white/10 mobile-menu-enter">
            <div className="flex flex-col space-y-4">
              {navLinks.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`font-body text-base py-2 ${
                    location.pathname === link.href
                      ? 'text-[#D4AF37]'
                      : 'text-[#A1A1AA]'
                  }`}
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid={`mobile-nav-${link.label.toLowerCase().replace(' ', '-')}`}
                >
                  {link.label}
                </Link>
              ))}
              
              {!isAdmin && (
                <Link
                  to="/apply"
                  onClick={() => setMobileMenuOpen(false)}
                  data-testid="mobile-join-now-btn"
                >
                  <Button className="btn-gold rounded-full w-full py-3 font-semibold">
                    Join Now
                  </Button>
                </Link>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
